module.exports = __webpack_public_path__ + "imgcvh/hero-6.922ffcc1.jpg";